import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PatientForm } from "./components/PatientForm";

export function PatientCreatePage() {
  // When arriving from a flow that must round-trip back (e.g. appointment booking,
  // #18561), ?returnTo=<path> sends the new patient back there via ?patientId=.
  const [params] = useSearchParams();
  const returnTo = params.get("returnTo");
  return (
    <div className="space-y-6 font-sans">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">
            Tạo bệnh nhân
          </h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            Nhập thông tin tối thiểu là họ tên. Các trường còn lại có thể bổ sung sau ở trang chi tiết.
            Hệ thống tự kiểm tra trùng theo CCCD, số điện thoại, họ tên + năm sinh.
          </p>
        </div>
        <div className="shrink-0">
          <Button asChild variant="outline" size="sm">
            <Link to="/patients">
              <ArrowLeft className="h-4 w-4" />
              Danh sách
            </Link>
          </Button>
        </div>
      </div>

      <PatientForm
        mode="create"
        onSuccessRedirect={(id) =>
          returnTo
            ? `${returnTo}${returnTo.includes("?") ? "&" : "?"}patientId=${id}`
            : `/patients/${id}`
        }
      />
    </div>
  );
}
